export default "__VITE_ASSET___5QoPxEu__"